module.exports = __webpack_public_path__ + "assets/edc35a93b9e0e0d8fc2c090109a86a34.mp3";